import { and, JsonFormsRendererRegistryEntry, rankWith, uiTypeIs, optionIs } from '@jsonforms/core';
import controlRenderer from './CustomEnumControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(50, and(uiTypeIs('CustomEnumControl'), optionIs('version', 'v2'))),
};
